import {
  TSO_TO_MARKET_ZONE_MAPPING,
  MARKET_ZONES_WITH_TSO_DATA,
  MARKET_ZONES,
  type MarketZoneId,
} from '@app/common/static-data/energy-markets';

// Use the unified market zones that have TSO GeoJSON data available
export const AVAILABLE_MAP_ZONES = MARKET_ZONES_WITH_TSO_DATA;

// Get market zone IDs that have map data
export const MAP_ZONE_IDS = AVAILABLE_MAP_ZONES.map((zone) => zone.id);

// Helper function to get zone label from market zone ID
export const getZoneLabel = (marketZoneId: MarketZoneId): string => {
  const zone = MARKET_ZONES.find((z) => z.id === marketZoneId);
  return zone?.label || marketZoneId;
};

// Helper function to get TSO zone file name from market zone ID
export const getTSOZoneFileName = (marketZoneId: MarketZoneId): string | null => {
  // Find the TSO zone key that maps to this market zone
  const tsoZoneKey = Object.keys(TSO_TO_MARKET_ZONE_MAPPING).find(
    (key) => TSO_TO_MARKET_ZONE_MAPPING[key] === marketZoneId,
  );
  return tsoZoneKey || null;
};

// Reverse mapping: Market Zone ID -> TSO Zone filename (only for zones with TSO data)
export const MARKET_TO_TSO_ZONE_MAPPING: Record<string, string> = {};
for (const [tsoZone, marketZone] of Object.entries(TSO_TO_MARKET_ZONE_MAPPING)) {
  MARKET_TO_TSO_ZONE_MAPPING[marketZone] = tsoZone;
}
